import { blogPost1, blogPost2, blogPost3 } from "../../../assets";
import { Button, Flex } from "antd";
import { useMediaQuery } from "react-responsive";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/effect-cards";
import { EffectCards } from "swiper/modules";

const BlogPost = () => {
  const isMobile = useMediaQuery({ query: "(max-width: 768px)" });

  return (
    <div>
      <div className="section-content mobile-padding-all">
        <div className="about-section-heading ">OUR NEWS</div>
        <Flex justify="space-between">
          <div className="section-heading">Recent Blog Posts </div>
          {!isMobile && (
            <Button className="gradient-outlined-button" shape="rounded">
              VIEW All NEWS
            </Button>
          )}
        </Flex>
        {!isMobile ? (
          <div className="card-section">
            <img src={blogPost1} alt="post1" className="post-img" />
            <img src={blogPost2} alt="post2" className="post-img" />
            <img src={blogPost3} alt="post3" className="post-img" />
          </div>
        ) : (
          <div style={{ overflow: "hidden" }}>
            <Swiper
              effect={"cards"}
              grabCursor={true}
              modules={[EffectCards]}
              className="mySwiper"
              loop={true}
            >
              <SwiperSlide className="post-img">
                {" "}
                <img src={blogPost1} alt="post1" className="p-img" />
              </SwiperSlide>
              <SwiperSlide className="post-img">
                {" "}
                <img src={blogPost2} alt="post2" className="p-img" />
              </SwiperSlide>
              <SwiperSlide className="post-img">
                {" "}
                <img src={blogPost3} alt="post3" className="p-img" />
              </SwiperSlide>
            </Swiper>
          </div>
          // <></>
        )}
      </div>
    </div>
  );
};
export default BlogPost;
